import { api } from 'services/api'

export async function createClient(payload) {
  const { data } = await api.post('/clients', payload)
  return data
}
